/* eslint-disable no-unused-vars */
export enum UserStatus {}

export enum ProfileType {
  ADMIN = 1,
  ADMIN_FUND = 2,
  ADMIN_FUND_TRANSACTION = 3,
}

export enum HomeStatementOption {
  ALL = 1,
  CASH_IN = 2,
  CASH_OUT = 3,
  SCHEDULED = 4,
}

export enum PixTransferType {
  NORMAL = 0,
  KEY = 1,
  STATIC = 2,
  DYNAMIC = 3,
}

export enum UserCredentialType {
  PASSWORD = 1,
  PIN = 2,
  RECOVERY_PASSWORD_TOKEN = 3,
  CHANGE_TOKEN = 4,
  PIX_SOLICITATION = 5,
  AUTH_DEVICE = 6,
  CARD_PASSWORD_PHYSICAL = 7,
  CARD_PASSWORD_VIRTUAL = 8,
}

export enum AccountSettingKeyEnum {
  ACCOUNT_PREVIOUS_STATE = 'ACCOUNT_PREVIOUS_STATE',
  CNAB_REQUIRED_APPROVALS = 'ACCOUNT_SETTINGS_CNAB_REQUIRED_APPROVALS',
  ACCOUNT_MIN_REQUEST_APPROVALS = 'ACCOUNT_SETTINGS_MIN_REQUEST_APPROVALS',
  PORTABILITY_ENABLE = 'PORTABILITY_ENABLE',
}

export enum AppSettingsKeyEnum {
  REQUIRED_APPROVALS = 'REQUIRED_APPROVALS',
  THEME_SELECTION = 'THEME_SELECTION',
  ACCOUNT_SETTINGS_DECISION_DESK_RETRY_TRANSACTION_MIN = 'ACCOUNT_SETTINGS_DECISION_DESK_RETRY_TRANSACTION_MIN',
}

export enum AccountConfigurationFieldsTypes {
  NUMBER = 'number',
  TEXT = 'text',
}

export enum AccountGroupType {
  ESCROW = 1,
}

export enum TransactionLimitStatusType {
  SUCCESS = 1,
  SEND_SOLICITATION = 2,
  PENDING = 3,
  DENIED = 4,
}

export enum PeriodType {
  DAILY = 1,
  NIGHTLY = 2,
}

export enum TransactionLimitType {
  TRANSACTION = 1,
  PERIOD = 2,
}

export enum AccountStatus {
  ONBOARD = 1,
  CREATE_REQUESTED = 1,
  APPROVED = 2,
  REPROVED = 3,
  BLOCKED = 4,
  CANCELED = 5,
  REJECTED = 6,
  REQUESTED_ADDRESS = 7,
  REQUESTED_SELF = 8,
  REQUESTED_DOCUMENTS = 9,
  REQUESTED_PIN = 10,
  PENDING_CREATE_COREBANK_CONFIRM = 11,
  PENDING_CREATE_COREBANK = 12,
  PENDING_ACCOUNT_DATA_RETRY = 14,
  PENDING_DOCUMENTS = 15,
  PENDING_APPROVAL = 16,
  PENDING_MANUAL_APPROVAL = 17,
  REQUESTED_POWER_OF_ATTORNEY = 18,
  REQUESTED_PARTNERS = 19,
  REQUESTED_LEGAL_REPRESENTOR = 20,
  REQUESTED_SELF_REPRESENTOR = 21,
  REQUESTED_DOCUMENT_REPRESENTOR = 22,
  PENDING_SOCIAL_CONTRACT = 25,
  PENDING_KYC_ANALYSIS = 28,
  PENDING_KYC_APPROVE = 29,
  ERROR_TO_CREATE = 999,
}

export enum AccountTaxIdentifierType {
  PERSON = 1,
  CORPORATE = 2,
  ALL = 3,
}

export enum ExportExtractMethod {
  DOWNLOAD = 1,
  EMAIL = 2,
}

export enum StatementFileType {
  PDF = 'pdf',
  CSV = 'csv',
  OFX = 'ofx',
  XLSX = 'xlsx',
}

export enum TransactionFlow {
  ALL = 0,
  CASH_IN = 1,
  CASH_OUT = 2,
  SCHEDULED = 4,
}

export enum PersonType {
  PERSON = 1,
  LEGAL = 2,
}

export enum TransactionType {
  P2P = 1,
  TED = 2,
  BILLET = 3,
  RECHARGE_BILLET = 4,
  DEPOSIT = 5,
  PIX = 6,
  CASHBACK = 7,
  RECHARGE_CELLPHONE = 8,
  TARIFF = 9,
  ATM_WITHDRAW = 10,
  ATM_DEPOSIT = 11,
  CREDIT = 12,
  DEBIT = 13,
  CARD_DEBIT = 14,
  BALANCE_BLOCK = 15,
  BALANCE_UNLOCK = 16,
  BILLET_PIX = 17,
  PAYMENT_LINK = 18,
  POINTS = 19,
  INVESTMENTS = 20,
  ACCOUNT_BALANCE = 21,
  TOTAL_AMOUNT = 22,
  PIX_WITHDRAW = 23,
  PIX_CHANGE = 24,
  QR_CODE = 25,
  MEMBER_GET_MEMBER_CASHBACK = 26,
  CARTAO_PRE_PAGO = 27,
  CANC_CARTAO_PRE_PAGO = 28,
  REVERSAL = 29,
  UNKNOWN = 100,
  P2P_TARIFF_CARD = 101,
  SALARY_PAYMENT = 201,
  ACCOUNT_SERVICE_INTEGRATION = 203,
  API_GATEWAY_PIX = 306,
}

export enum QrCodeOperation {
  WITHDRAWAL = 'WITHDRAWAL',
  CHANGE = 'CHANGE',
  TRANSFER = 'TRANSFER',
}

export enum PixReversalReasons {
  FRAUD = 'FRAUD',
  OPERATIONAL_FLAW = 'OPERATIONAL_FLAW',
  REFUND_CANCELLED = 'REFUND_CANCELLED',
}

export enum TransactionStatus {
  PENDING_CONFIRM = 1,
  EXECUTED = 2,
  FAILED = 3,
  REVERSAL = 4,
  REPROVED = 5,
  PENDING_CREATE = 6,
}

export enum Permission {
  MANAGE_ADMIN = 'manage-admin',
  MANAGE_DASHBOARD = 'manage-dashboard',
  MANAGE_PUSH_NOTIFICATION = 'manage-push-notifications',
  MANAGE_USER = 'manage-user',
  MANAGE_CASHBACK = 'manage-cashback',
  MANAGE_GROUPS = 'manage-groups',
}

export enum RepresentorType {
  BUSINESS_PARTNER = 1,
  PROCURATOR = 2,
  LEGAL_REPRESENTOR = 3,
  CORPORATE = 4,
}

export enum DeviceType {
  ANDROID = 1,
  IOS = 2,
  WEB = 3,
}

export enum CompanyType {
  MEI = 1,
  EI = 2,
  ME = 3,
  EPP = 4,
  EIRELI = 5,
  LTDA = 6,
  SA = 7,
}

export enum DetailType {
  DETAIL,
  NEW,
}

export enum PayableGroupStatus {
  PROCESSING = 1,
  EXECUTED = 2,
  WAITING_APPROVAL = 3,
  PORTABILITY_EXECUTED = 4,
  REPROVED = 5,
  APPROVED_WITH_ERROR = 6,
  SCHEDULED = 13,
}

export enum PayableVoteAction {
  APPROVE = 1,
  REPROVE = 2,
}

export enum PayableStatus {
  PROCESSING = 1,
  EXECUTED = 2,
  ERROR = 3,
  ERROR_CORE_BANK = 4,
  WAITING_APPROVAL = 5,
  PORTABILITY_EXECUTED = 6,
  REPROVED = 7,
  PAYMENT_TYPE_NOT_FOUND = 8,
  ERROR_INVALID_INPUT = 9,
  ERROR_ACCOUNT_NOT_FOUND = 10,
  ERROR_EMPLOYEE_NOT_BELONG_THIS_COMPANY = 11,
  ERROR_EMPLOYEE_NOT_CREATED = 12,
  SCHEDULED = 13,
}

export enum ReceivableStatus {
  PENDING = 1,
  PAID = 2,
  OVERDUE = 3,
  EXPIRED = 4,
  CREATING = 5,
  ERROR = 6,
  PENDING_PAYER_CREATE = 7,
  PENDING_PAYMENT = 8,
}

export enum FeatureType {
  PAYROLL_LOAN_URL = 'PAYROLL_LOAN_URL',
  CASHBACK_PARTNER = 'cashbackPartner',
}

export enum PaymentMode {
  PAYABLE = 'PAYABLE',
  RECEIVABLE = 'RECEIVABLE',
  PAYSLIP = 'PAYSLIP',
}

export enum FileTypePayable {
  CNAB = 1,
  CSV = 2,
}

export enum PayableType {
  TRANSFER = 1,
  SALARY_PAYMENT = 2,
}

export enum PayStubType {
  THIRTEENTH_FIRST = 1,
  THIRTEENTH_SECOND = 2,
  FOURTEENTH = 3,
  PARTIAL_NORMAL_SHEET = 4,
  NORMAL_SHEET = 5,
  AWARD = 6,
  VACATION = 7,
  BONUS = 8,
  COMPLEMENT = 9,
  ADVANCE = 10,
  ANTICIPATION = 11,
  PROOF_1 = 12,
  PROOF_2 = 13,
  PROOF_3 = 14,
  PROOF_4 = 15,
  PAYMENT = 16,
  GRATIFICATION = 17,
  PLR = 18,
  WAGE_ALLOWANCE = 19,
  PARTIAL_PAYMENT = 20,
  NORMAL_PAYMENT = 21,
}

export enum AdvancedFilterType {
  TEXT = 1,
  SELECT = 2,
  DATE_PICKER = 3,
  CHECKBOX = 4,
  RADIO = 5,
  RANGE_PICKER = 6,
  AUTO_COMPLETE = 7,
}

export enum Weekday {
  SATURDAY = 6,
  SUNDAY = 7,
}

export enum ProductType {
  ALL = 0,
  LCA = 1,
  CDB = 2,
  LCI = 3,
  LC = 4,
}

export enum IndexerType {
  CDI = 1,
  PRE = 2,
  IPCA = 3,
}

export enum InvestmentFlow {
  ALL = 0,
  REDEMPTION = 1,
  ISSUE = 2,
  EARLY_REDEMPTION = 3,
}

export enum StatementProofType {
  TRANSACTION = 1,
  INVESTMENT = 2,
  TRADING_NOTES = 3,
}

export enum StatusOperator {
  PENDING_LOGIN = 1,
  PENDING_LINKING = 2,
  LINKING = 3,
}

export enum AdditionalBilletlInfo {
  CELLPHONE = 'cellphone',
  EMAIL = 'email',
  TAXIDENTIFIER = 'taxIdentifier',
  NAME = 'name',
}

export enum InvestmentProductType {
  ALL = '0',
  LCA = '1',
  CDB = '2',
  LCI = '3',
  LC = '4',
}

export enum InvestmentProduct {
  LCA = 'LCA',
  CDB = 'CDB',
  LCI = 'LCI',
  LC = 'LC',
}

export enum InvestmentIndexerType {
  CDI = 'CDI',
  PRE = 'PRE',
  IPCA = 'IPCA',
}

export enum DownloadAccountPayableType {
  CSV = 'TEMPLATE_PAYABLE_BETA_CSV',
  CNAB = 'MODEL_CNAB_240_FEBRABAN',
}

export enum DeviceOSEnum {
  ANDROID = 'android',
  APPLE = 'apple',
  FIREFOX = 'firefox',
  CHROME = 'chrome',
  EDGE = 'edge',
  IOS = 'ios',
}
